export default {
    EXAME_LABORATORIAL: 1,
    EXAME_IMAGEM: 2,
    EXAME: 3,
    PROCEDIMENTO_CIRURGICO: 4,
    ESPECIALIDADE: 5,
}